<template>
  <b-navbar
    toggleable="lg"
    type="light"
    variant="white"
    fixed="top"
    class="shadow-sm"
  >
    <b-navbar-brand class="d-flex align-items-center">
      <b-link href="https://www.dripcapital.com/">
        <b-img
          alt="header-logo"
          title="Drip"
          :src="require(`@/assets/images/drip-logo.svg`)"
          :width="105"
        />
      </b-link>
      <b-img
        alt="Path"
        title="Path"
        :src="require(`@/assets/images/path.png`)"
        width="2"
        height="28"
      />
      <b-link class="ml-4 product-header" :to="{ name: 'home' }"
        >HS CODE</b-link
      >
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse is-nav id="nav-collapse">
      <b-navbar-nav class="d-lg-flex justify-content-between w-100">
        <div class="d-lg-flex align-items-center">
          <b-nav-item href="https://www.dripcapital.com/en-in" class="mr-2">
            For Exporter
          </b-nav-item>

          <b-nav-item
            href="https://www.dripcapital.com/en-in/investors"
            class="mr-2"
          >
            For Investor
          </b-nav-item>

          <b-nav-item href="https://www.dripcapital.com/en-in/partners">
            Partner
          </b-nav-item>
        </div>
        <div class="d-lg-flex align-items-center justify-content-end">
          <b-nav-item class="mr-2">
            <b-nav-item-dropdown
              text="Company"
              class="mr-1 header d-none d-lg-block"
            >
              <b-dropdown-item
                @click.native="e => redirectTo(e)"
                href="https://www.dripcapital.com/en-in/about"
              >
                About Us
              </b-dropdown-item>
              <b-dropdown-item
                @click.native="e => redirectTo(e)"
                href="https://www.dripcapital.com/en-in/contact"
              >
                Contact
              </b-dropdown-item>
              <b-dropdown-item
                @click.native="e => redirectTo(e)"
                href="https://www.dripcapital.com/en-in/leadership"
              >
                Leadership Team
              </b-dropdown-item>
              <b-dropdown-item
                @click.native="e => redirectTo(e)"
                href="https://www.dripcapital.com/careers"
              >
                Careers
              </b-dropdown-item>
              <!-- <b-dropdown-item
                @click.native="e => redirectTo(e)"
                href="https://www.dripcapital.com/support"
              >
                FAQs
              </b-dropdown-item> -->
            </b-nav-item-dropdown>
          </b-nav-item>

          <b-nav-item class="mr-2">
            <b-nav-item-dropdown
              text="Resources"
              class="mr-1 header d-none d-lg-block"
            >
              <b-dropdown-item
                @click.native="e => redirectTo(e)"
                href="https://www.dripcapital.com/en-in/resources/blog"
              >
                Blog
              </b-dropdown-item>
              <b-dropdown-item @click.native="e => redirectTo(e)" to="/">
                HSN Code Finder
              </b-dropdown-item>
              <b-dropdown-item
                @click.native="e => redirectTo(e)"
                href="https://www.dripcapital.com/en-in/glossary-of-shipping-terms"
              >
                Glossary
              </b-dropdown-item>
              <b-dropdown-item
                @click.native="e => redirectTo(e)"
                href="https://www.dripcapital.com/en-in/resources/finance-guides"
              >
                Finance Guides
              </b-dropdown-item>
            </b-nav-item-dropdown>
          </b-nav-item>

          <b-nav-item
            href="https://portal.dripcapital.com/login"
            class="mr-4 pr-2"
          >
            Sign In
          </b-nav-item>

          <div class="nav-item mr-3">
            <button-arrow @click.native="applyNow">Apply Now</button-arrow>
          </div>
        </div>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import ButtonArrow from '../components/ButtonArrow'
export default {
  methods: {
    applyNow() {
      window.location.href = 'https://www.dripcapital.com/en-in/exporters/apply'
    },
    redirectTo(e) {
      window.location.href = e.target.href
    }
  },
  components: {
    ButtonArrow
  }
}
</script>

<style lang="scss" scoped>
.product-header {
  text-decoration: none;
  color: $secondary;
}
</style>
